module.exports = __webpack_public_path__ + "static/media/checkstyle01.36be920b.png";